export const GET_CUSTOM_GROUP_LIST_REQUEST = 'GET_CUSTOM_GROUP_LIST_REQUEST';
export const GET_CUSTOM_GROUP_LIST_SUCCESS = 'GET_CUSTOM_GROUP_LIST_SUCCESS';
export const GET_CUSTOM_GROUP_LIST_FAILURE = 'GET_CUSTOM_GROUP_LIST_FAILURE';

export const SET_CUSTOM_GROUP_LIST_PAGE_INDEX = 'SET_CUSTOM_GROUP_LIST_PAGE_INDEX';
export const SET_CUSTOM_GROUP_LIST_SEARCH_QUERY = 'SET_CUSTOM_GROUP_LIST_SEARCH_QUERY';
export const SET_CUSTOM_GROUP_LIST_SORT = 'SET_CUSTOM_GROUP_LIST_SORT';

export const RESET_CUSTOM_GROUP_LIST_FILTER = 'RESET_CUSTOM_GROUP_LIST_FILTER';
export const SET_CUSTOM_GROUP_SUCCESS = 'SET_CUSTOM_GROUP_SUCCESS';
